<template>
    <!-- Header -->
    <!-- Available header.navbar classes: 'navbar-light bg-light' for the
    default light header 'navbar-dark bg-dark' for an alternative dark header
    'fixed-top' for a top fixed header (fixed main sidebar with scroll will
    be auto initialized, functionality can be found in js/app.js - handleSidebar())
    'header-fixed-top' has to be added on #page-container only if the class
    'fixed-top' was added 'navbar-fixed-bottom' for a bottom fixed header (fixed
    main sidebar with scroll will be auto initialized, functionality can be
    found in js/app.js - handleSidebar())) 'header-fixed-bottom' has to be
    added on #page-container only if the class 'navbar-fixed-bottom' was added
    -->
     <header class="navbar navbar-dark bg-dark fixed-top navbar-expand-md" style="z-index: 10000 !important">
        <!-- Left Header Navigation -->
        <ul class="nav navbar-nav-custom">
            <!-- Main Sidebar Toggle Button -->
            <li class="nav-item">
                <a href="javascript:void(0)" class="nav-link" @click="sidebarToggle">
                    <i class="fa fa-ellipsis-v fa-fw animation-fadeInRight" id="sidebar-toggle-mini"></i>
                    <i class="fa fa-bars fa-fw animation-fadeInRight" id="sidebar-toggle-full"></i>
                </a>
            </li>
            <!-- END Main Sidebar Toggle Button -->
            <!-- Header Link -->
            <li class="hidden-xsd-none d-sm-block animation-fadeInQuick nav-item">
                <a href="" class="nav-link"><strong>Bienvenido a Gestión</strong></a>
            </li>
            <!-- END Header Link -->
        </ul>
        <!-- END Left Header Navigation -->
        <!-- Right Header Navigation -->
        <ul class="nav navbar-nav-custom float-right">
            <!-- Search Form -->
            <!--li class="nav-item">
                <form action="page_ready_search_results.html" method="post" class="form-inline-custom">
                    <input type="text" id="top-search" name="top-search" class="form-control" placeholder="Buscar...">
                </form>
            </li-->
            <!-- END Search Form -->
            <!-- Alternative Sidebar Toggle Button -->
            <li class="nav-item" v-if="!call_in_progress">
                <span class="nav-link">
                    <font-awesome-icon :icon="external_pause?'pause-circle':'phone'" @click="pauseAgent" v-tooltip.bottom="external_pause?'Reanudar Marcador':'Pausar Marcador'"></font-awesome-icon>
                </span>
            </li>
            <li class="nav-item" v-if="call_in_progress">
                <span class="nav-link">
                    <font-awesome-icon :icon="park_call?'microphone-slash':'microphone'" @click="parkCall" v-tooltip.bottom="park_call?'Reanudar Llamada':'Pausar Llamada'"></font-awesome-icon>
                </span>
            </li>
            <li class="nav-item" v-if="call_in_progress">
                <span class="nav-link">
                    <font-awesome-icon :icon="'phone-slash'" @click="colgarLLamada" v-tooltip.bottom="'Colgar Llamada'"></font-awesome-icon>
                </span>
            </li>
            <li class="nav-item">
                <a href="javascript:void(0)" onclick="App.sidebar(&apos;toggle-sidebar-alt&apos;);this.blur();" class="nav-link">
                    <i class="gi gi-settings"></i>
                </a>
            </li>

            <!-- END Alternative Sidebar Toggle Button -->
            <!-- User Dropdown -->
            <li class="dropdown nav-item" v-bind:class="{ open: userNavItem }" v-on:click="userNavItem = !userNavItem" style="margin-right: 10px;">
                <a href="javascript:void(0)" class="dropdown-toggle nav-link" data-toggle="dropdown">
                    <img src="/images/placeholders/avatars/avatar9.jpg" alt="avatar">
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                    <li class="dropdown-header dropdown-item" v-if="user"> <strong>{{ user.nombres }} {{ user.apellidos }}</strong></li>
                    <li class="dropdown-item">
                        <router-link :to="'/change-password'" >
                            <i class="fa fa-key fa-fw float-right"></i>
                            Cambiar contraseña
                        </router-link>
                    </li>
                    <li class="dropdown-item">
                        <a href="" @click="logout">
                            <i class="fa fa-power-off fa-fw float-right"></i>
                            Cerrar Sesión
                        </a>
                    </li>
                </ul>
            </li>
            <!-- END User Dropdown -->
        </ul>
        <!-- END Right Header Navigation -->
    </header>
    <!-- END Header -->
</template>
<script>
export default {
  data: () => {
    return {
      userNavItem: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    external_pause() {
      return this.$store.getters["vicidial/external_pause"] || false;
    },
    park_call() {
      return this.$store.getters["vicidial/park_call"] || false;
    },
    call_in_progress() {
      return this.$store.getters["vicidial/call_in_progress"] || false;
    }
  },
  methods: {
    sidebarToggle() {
      this.$emit("sidebarToggle");
    },
    logout() {
      this.$store.dispatch("user/logout");
    },
    pauseAgent() {
      this.$store.dispatch("vicidial/pausarReanudarAgente");
    },
    parkCall() {
      this.$store.dispatch("vicidial/parkCall");
    },
    colgarLLamada() {
      this.$store.dispatch("vicidial/colgarLlamada");
      this.$store.dispatch("vicidial/tipificarLlamada", { value: "N" });
      this.$router.push({ name: "home" });
    }
  }
};
</script>